import { Settings } from 'lucide-react';

import { useSetShowSettingsPopup } from '../store/hooks';

export function SettingsButton() {
  const setShowSettingsPopup = useSetShowSettingsPopup();
  return (
    <button
      onClick={() => setShowSettingsPopup(true)}
      className="text-gray-400 hover:text-white hover:scale-105 hover:shadow-[0_0_10px_rgba(79,70,229,0.3)] transition-all duration-300 ease-in-out p-2 rounded-lg hover:bg-[#1a2d4d]/30"
      aria-label="Open settings"
    >
      <Settings className="w-5 h-5" />
    </button>
  );
}
